import axios from '@/utils/axios'

export const getDuizhangdan = (payload) => {
    return axios.get('/duizhangdan', {
        params: payload
    })
}

export const createDuizhangdan = (data) => {
    return axios.post('/duizhangdan', data)
}

export const updateDuizhangdan = (id, data) => {
    return axios.put(`/duizhangdan/${id}`, data)
}

export const deleteDuizhangdan = (id) => {
    return axios.delete(`/duizhangdan/${id}`)
}